import type { FlightDetailCopy } from '@voll-intelligence/intelligence-ui-kit';
import { genUiI18n, type GenUiTranslate } from './i18n.js';

/** Os textos do detalhe do voo do kit pelo tradutor do chat. */
export function flightDetailCopyOf(t: GenUiTranslate): FlightDetailCopy {
  return {
    title: t('flightDetail.title'),
    seatMapTitle: t('flightSeatMap.sectionTitle'),
    drawerAria: t('flightDetail.drawerAria'),
    backAria: t('flightDetail.backAria'),
    select: t('flightDetail.select'),
    loading: t('flightDetail.loading'),
    loadError: t('flightDetail.loadError'),
    quoteExpired: t('flightSeatMap.quoteExpired'),
    partnerDataNote: t('flightDetail.partnerDataNote'),
    dirOutbound: t('flightDetail.dirOutbound'),
    dirReturn: t('flightDetail.dirReturn'),
    continuesOn: (flight) => t('flightDetail.continuesOn', { flight }),
    aircraftChange: t('flightDetail.aircraftChange'),
    connection: (duration, airport) => t('flightDetail.connection', { duration, airport }),
    flightDuration: (duration) => t('flightDetail.flightDuration', { duration }),
    operatedBy: (name) => t('flightDetail.operatedBy', { name }),
    soldAs: (flights) => t('flightDetail.soldAs', { flights }),
    onTimeStat: (percent, count) => t('flightDetail.onTimeStat', { percent, count }),
    terminal: (terminal) => t('flightDetail.terminal', { terminal }),
  };
}

/** Os textos do detalhe do voo no locale do host. Função pura: o host memoiza
 *  por locale. */
export function flightDetailCopy(locale: string | null | undefined): FlightDetailCopy {
  return flightDetailCopyOf(genUiI18n(locale).t);
}
